import { useQuery } from '@tanstack/react-query';
import { Grid } from 'antd-mobile';
import { GridItem } from 'antd-mobile/es/components/grid/grid';
import { NavListContext } from 'App';
import { useContext, useEffect, useState } from 'react';
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai';
import { PagePostDT } from 'services/apis/cnt2/post-api';
import termsApi, { TermsNodeListDT } from 'services/apis/cnt2/term-api';
import ImageListPullScroll from '../image-list-pull-scroll';

const TermPostList = (data: {
  termId: string;
  termTaxonomy: string;
  termName?: string;
  showTermNamePrefix: boolean;
  sortType: string;
  changeIndexEnabled: boolean;
  staticPostList?: PagePostDT[];
}) => {
  // console.log('TermPostList', data);
  const [expandSortType, toggleExpandSortType] = useState(true); // 是否展开排序按钮
  const updateNavList = useContext(NavListContext).updateNavList;

  const [collapse, setCollapse] = useState<boolean>(true);
  const navList = useContext(NavListContext).navList;
  const termId = data.termId
    ? data.termId
    : navList.top2TermNow?.termUuid || navList.top1TermNow?.termUuid || navList.btmTermNow?.termUuid;
  // const [topicsList, setTopicsList] = useState<TermsNodeListDT>(null);
  // const fetchTermPostList = async () => {
  //   const result = await termsApi.treeTerm({ parentTermId: termId, termTaxonomy: data.termTaxonomy }, {});
  //   if (result.code === 0 && result.successful) {
  //     // setTopicsList(result.result);
  //     return result.result;
  //   }
  // };

  // const fetchTermPostListQuery = useQuery({
  //   queryKey: ['fetchTagList', { parentTermId: termId, termTaxonomy: data.termTaxonomy }],
  //   queryFn: () => {
  //     return fetchTermPostList();
  //   },
  // });

  // useEffect(() => {
  //   fetchTermPostList();
  // }, [termId]);

  return (
    <>
      <ImageListPullScroll
        sortType={data.sortType}
        termTaxonomy={data.termTaxonomy}
        termName={data.termName}
        showTermNamePrefix={data.showTermNamePrefix}
        termId={termId}
        changeIndexEnabled={data.changeIndexEnabled}
        onIndexChange={(index) => {
          console.log('change-index', index);
          updateNavList((draft) => {
            draft.top2TermNow = draft.top2TermList[index];
          });
        }}
        staticPostList={data.staticPostList}
      />
    </>
  );
};
export default TermPostList;
